export function newEl(p, props) {
	const [tag, ...classes] = p.split(".");
	const c = document.createElement(tag);
	for (const n of classes) c.classList.add(n);
	for (const prop in props) c[prop] = props[prop];
	return c;
}

export function child(parent, p, props) {
	const c = newEl(p, props);
	parent.appendChild(c);
	return c;
}

export function upTo(el, predicate) {
	while (el) {
		if (predicate(el)) return el;
		el = el.parentElement;
	}
	return null;
}

export function setClass(el, name, condition) {
	if (condition) el.classList.add(name);
	else el.classList.remove(name);
}

export function text(el, text) {
	el.appendChild(document.createTextNode(text));
}
